import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./AddWaterContainerToPalletForm";
import {LIST_PRODUCTS} from "../../../queries/inventory";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelAddWaterContainerToPallet} from "../../../actions/InventoryApiActions";
import {fromJS, Map, List} from "immutable";
import {validatePresence, validateIncludes} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

const resultOptions = fromJS([
  { id: "pending", title: "Pending"},
  { id: "inherit", title: "Inherit from Pallet"},
  { id: "accepted", title: "Accepted" },
  { id: "rejected", title: "Rejected" }
]);

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "serial");
  errors = validateIncludes(errors, values, "testResult", resultOptions.map(x => x.get("id")));
  if (List(["accepted", "rejected"]).includes(values.get("testResult"))) {
    errors = validatePresence(errors, values, "labName");
    errors = validatePresence(errors, values, "testNr");
  }
  return errors.toJS();
}

class AddWaterContainerToPalletFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("palletId", this.props.palletId);
    return this.props.addNewWaterContainerToPallet(updatedValues.toJS())
      .then((response) => {
        if (response.data.addNewWaterContainerToPallet.errors.length <= 0) {
          this.props.cancelAddWaterContainerToPallet();
        } else {
          let errors = createValidationErrors(response.data.addNewWaterContainerToPallet.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAddWaterContainerToPallet();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />     
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        products={fromJS(data.products)}
        resultOptions={resultOptions}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const ADD_NEW_WATER_CONTAINER = gql`
  mutation addNewWaterContainerToPallet($data: WaterContainerToPalletInput!) {
    addNewWaterContainerToPallet(input: $data) {
      errors { key message }
    }
  }
`

const withQueries = compose(
  graphql(LIST_PRODUCTS, {
    options: (props) => ({
      fetchPolicy: "network-only"
    })
  }),  
  graphql(ADD_NEW_WATER_CONTAINER, {
    props: ({ mutate }) => ({
      addNewWaterContainerToPallet: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const AddWaterContainerToPalletFormContainerWithData = withQueries(AddWaterContainerToPalletFormContainer);

export default connect(null, {cancelAddWaterContainerToPallet})(AddWaterContainerToPalletFormContainerWithData);